<template>
  <div class="exp-communicate">
    <div class="top">
      <div class="top-title">
        <div>
          <img :src="topMenus.iconPath" alt="" />
          {{ topMenus.value }}
        </div>
      </div>
      <div class="padding_box">
        <div class="input_box">
          <el-input
            type="textarea"
            v-model="question"
            :autosize="{ minRows: 3 }"
            maxlength="200"
            show-word-limit
            :placeholder="$t('lang.external.fzsy.content.home.请输入评价内容')"
          />
          <div class="evaluate_box">
            <div class="rateTip">
              <span>{{
                $t('lang.external.fzsy.content.home.实验评价：')
              }}</span>
            </div>
            <div class="rate">
              <el-rate
                v-model="score"
                :allow-half="true"
                :colors="['#A63528', '#A63528', '#A63528']"
              >
              </el-rate>
            </div>
          </div>
        </div>

        <div class="top-btn">
          <span class="btn1" @click="submit">{{
            $t('lang.external.fzsy.content.home.提交评价')
          }}</span>
        </div>
      </div>
    </div>

    <div class="bottom">
      <div class="bottom-title">
        {{ $t('lang.external.fzsy.content.home.实验评价') }}（{{ +AllCounts }}）
      </div>
      <div class="bottom-comments">
        <div
          class="bottom-comments-item"
          v-for="comment in comments"
          :key="comment.id"
        >
          <div class="comment-main">
            <div class="comment-main-portrait">
              <img :src="comment.photo" alt="" />
            </div>
            <div class="comment-main-content">
              <p class="name">{{ comment.stuName }}</p>
              <p class="comment">{{ comment.content }}</p>
            </div>
          </div>
        </div>
      </div>
      <paginationChange :pageData="pageData" @chagePage="changePage" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { expComment, expCommentSubmit } from '@/api/experiment/index'
import paginationChange from '../../common/paginationChange.vue'
export default {
  name: 'exp-communicate',
  components: { paginationChange },
  inject: ['expId'],
  data() {
    return {
      score: 0,
      AllCounts: 0,
      pageData: {
        total: 24,
        pageSize: 4,
        page: 1,
      },
      colors: ['#99A9BF', '#F7BA2A', '#FF9900'],
      defaultTopSelect: 1,
      topMenus: {
        iconPath: require('@/img/node.png'),
        value: this.$t('lang.external.fzsy.content.home.实验评价'),
      },
      rateValue() {
        return parseFloat(this.data.score)
      },
      question: '',
      comments: '',
      timer: null,
    }
  },
  watch: {},
  computed: {
    ...mapState(['userInfo']),
  },
  created() {
    this.getComment()
  },
  mounted() {},
  methods: {
    topChange(val) {
      this.defaultTopSelect = val
    },
    cancelComment() {
      this.activeComment = undefined
    },
    changePage(e) {
      this.pageData.page = e
      this.getComment()
    },
    submit() {
      if (!window.localStorage.getItem('token')) {
        this.$notify({
          type: 'error',
          message: this.$t('lang.external.fzsy.content.home.请先登录！'),
          duration: 1500,
          title: 'ERROR',
        })
        return
      }
      if (!this.question) {
        this.$notify({
          type: 'error',
          message: this.$t(
            'lang.external.fzsy.content.home.评论内容不能为空！'
          ),
          duration: 1500,
          title: this.$t('lang.external.fzsy.content.home.评论失败'),
        })
        return
      }
      //expId设置默认值
      if (!window.localStorage.getItem('expId')) {
        window.localStorage.setItem('expId', 1)
      }
      //提交评论
      var that = this
      if (this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        expCommentSubmit({
          course_id: window.localStorage.getItem('expId'),
          content: this.question,
          starLevel: that.score,
        }).then((res) => {
          that.$notify({
            type: 'success',
            message: res.msg,
            duration: 1500,
            title: this.$t('lang.external.fzsy.content.home.评论成功'),
          })
          that.getComment()
        })
      }, 500)
    },

    getComment() {
      var that = this
      expComment({
        course_id: window.localStorage.getItem('expId'),
        limit: this.pageData.pageSize,
        page: this.pageData.page,
      }).then((res) => {
        const { data } = res.data
        that.pageData.total = res.data.total
        that.pageData.pageSize = res.data.per_page
        that.AllCounts = res.data.total
        this.comments = data
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.exp-communicate {
  width: 100%;
  color: #666666;
  margin-top: 30px;
  background-color: #edf2f6;
  border-radius: 5px;
  p {
    margin: 0;
  }
  .name {
    color: #666666;
  }
  .comment {
    font-size: 16px;
    color: #999999;
  }
  .top {
    &-title {
      display: flex;
      align-items: center;
      color: #0c5893;
      font-weight: bold;
      img {
        height: 16px;
        margin-right: 10px;
      }
      div {
        height: 51px;
        flex: 1;
        box-sizing: border-box;
        padding-left: 20px;
        line-height: 51px;
        border-bottom: 1px solid #ccd4da;
      }
    }
    &-btn {
      padding: 15px 0px 20px 0px;
      border-bottom: 1px solid #ccd4da;
      .btn1 {
        font-size: 16px;
        padding: 5px 18px;
        border-radius: 5px;
        background-color: #fff;
        background-image: url(../../../img/button.png);
        background-size: 100% 100%;
      }
    }
    .el-textarea {
      margin: 15px 0;
      ::v-deep .el-textarea__inner {
        border: none;
      }
    }
  }
  .bottom {
    padding: 0px 20px 20px 20px;
    margin-top: 25px;
    &-title {
      color: #0c5893;
      margin-bottom: 18px;
      font-weight: bold;
    }
    &-comments {
      &-item {
        display: flex;
        flex-direction: column;
        background: #ffffff;
        padding: 20px;
        box-shadow: 1px 1px 1px 0px rgba(194, 212, 224, 0.53);
        margin-bottom: 15px;
        border-radius: 15px;
        .comment-main {
          width: 100%;
          display: flex;
          &-portrait {
            img {
              width: 53px;
              height: 53px;
              border-radius: 50%;
            }
          }
          &-content {
            width: 100%;
            padding: 0 20px;
            p {
              margin: 0;
            }
          }
          &-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 8rem;
            cursor: pointer;
            .active {
              color: #a63528;
            }
            img {
              width: 20px;
              margin-right: 10px;
            }
          }
        }
        .comment-box {
          height: 0;
          overflow: hidden;
          transition: all 0.3s;
          padding-left: 20px;
          .comment-create {
            display: flex;
            align-items: center;
            padding-bottom: 15px;
            border-bottom: 1px solid #edf2f6;
            &-portrait {
              img {
                width: 42px;
                height: 42px;
                border-radius: 50%;
              }
            }
            &-input {
              width: 100%;
              margin: 0 1rem;
              ::v-deep .el-textarea__inner {
                background: #edf2f6;
              }
            }
            &-btns {
              width: 215px;
              display: flex;
              align-content: center;
              span {
                font-size: 14px;
                padding: 6px 15px;
                border-radius: 3px;
                cursor: pointer;
              }
              .submit {
                color: white;
                background: #0c5893;
                margin-right: 15px;
              }
              .cancel {
                color: #666666;
                background: #edf2f6;
              }
            }
          }
          .comment-reply {
            padding-top: 15px;

            &-item {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-top: 5px;
              &-portrait {
                img {
                  width: 42px;
                  height: 42px;
                  border-radius: 50%;
                }
              }
              &-content {
                width: calc(100% - 212px);
              }
              &-time {
                width: 125px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                img {
                  width: 20px;
                  margin-right: 10px;
                }
              }
            }
          }
        }
      }
    }
  }
}
.padding_box {
  padding: 9px 20px 0px 20px;
}
.topActive {
  background-color: #0c5893;
  color: #fff;
}
.pagination_box {
  padding-top: 22px;
  padding-bottom: 18px;
  ::v-deep {
    .el-pagination {
      text-align: center;
    }
    .el-pager li {
      width: 34px;
      height: 34px;
      margin: 0px 3px 0px 3px;
      border-radius: 3px;
      line-height: 34px;
    }
    .el-pagination .btn-next {
      width: 62px;
      height: 34px;
      border-radius: 3px;
      padding-right: 10px;
      color: #666666;
      font-weight: bold;
      margin-left: 11px;
    }
    .el-pagination .btn-prev {
      width: 62px;
      height: 34px;
      border-radius: 3px;
      padding-right: 10px;
      color: #666666;
      font-weight: bold;
      margin-right: 11px;
      box-sizing: border-box;
      font-size: 12px;
    }
    .el-pagination .el-pager li:not(.disabled).active {
      background-color: rgba(#0c5893, 1); // 进行修改选中项背景和字体
      color: #fff;
    }
  }
}
.input_box {
  display: flex;
}
.rate {
  text-align: center;
}
.evaluate_box {
  width: 202px;
  background-color: #fff;
  height: 91px;
  border-radius: 5px;
  margin-top: 14px;
  justify-content: center;
  // align-items: center;
  // text-align: center;
  display: flex;
  flex-direction: column;
  margin-left: 20px;
  flex-shrink: 0;
  span {
    font-size: 16px;
    color: #666;
    font-weight: bold;
  }
}
.rateTip {
  padding-left: 20px;
}
.bottom-title {
  font-size: 18px;
}
</style>